import React from "react";
import { Exam_Explore_data} from "./Exam_Explore_data";
import "./exam.css";
import { Link } from "react-router-dom";


const ExamExplore = ({Sectionref}) => {
  return (
    <div id="exam" ref={Sectionref}>
      <div className="exam-pathMain-container">
      <h2>EXPLORE EXAMS</h2>
      <div className="exam_sub_container">
        <div className="exam_box_right">
          {Exam_Explore_data.map((data, index) => (
            <div
              key={index}
              className={`${data.exam_boxs} exam_card ${
                data.imageFit === "cover" ? "exam_card--cover" : ""
              }`}
            >
            
              <div className="examheadingImage exam_card_media">
                     <img src={data.exam_image} className="imgexam" alt={data.exams_button} />
              </div>
              <div className="linksdisplayonhover exam_card_body">
           
                <h3> {data.exams_button}</h3>
                <Link 
                  onClick={() => window.scrollTo(0, 0)}
                  to={data.examPage}
                  className={data.exams_buttons}
                >
                  GET STARTED
                </Link>
              </div>
            </div>
          ))}
        </div>

       
      </div>

    </div>
        </div>
  );
};

export default ExamExplore;
